// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"31d6cfe0","596":"72f5c02f","741":"a5dbf836"}[chunkId] + ".chunk.css";
};